<div class="ad-popup-container ad-issue-modal">

  <!-- ───────────────────────────────────────────────────────────── Header -->
  <div class="modal-header ad-issue-head">
    <div class="ad-issue-head__lead">
      <span class="ad-issue-head__icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
          <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6">
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0" />
            <path d="M12 9v4m0 4h.01" />
          </g>
        </svg>
      </span>
      <div class="ad-issue-head__copy">
        <h4 class="modal-title">Order issue</h4>
        <p class="ad-issue-head__sub">
          @if (orderData?.orderId) {
          <span class="ad-issue-head__order">Order #{{ orderData.orderId }}</span>
          }
        </p>
      </div>
    </div>

    <div class="ad-issue-head__tail">
      <!-- @if (issueForm.value.refund_status_to_cus) {
      <span class="ad-status-chip" [class.is-refunded]="issueForm.value.refund_status_to_cus === 'Refunded'"
        [class.is-declined]="issueForm.value.refund_status_to_cus === 'Decline'">
        <span class="ad-status-chip__dot" aria-hidden="true"></span>
        {{ issueForm.value.refund_status_to_cus === 'Refunded' ? 'Refunded' : 'Declined' }}
      </span>
      } -->
      <button type="button" aria-label="Close" class="ad-close-btn" (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
            d="m7 7l10 10M7 17L17 7" stroke-width="1"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- ─────────────────────────────────────────────────────────────── Body -->
  <div class="card-body ad-booking-order-container">
    <form [formGroup]="issueForm" autocomplete="off" class="ad-issue-form">

      <!-- ── What went wrong ─────────────────────────────────────────── -->
      <section class="ad-form-section">
        <div class="ad-form-section__head">
          <span class="ad-form-section__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6M9 15h6" />
              </g>
            </svg>
          </span>
          <div>
            <h5 class="ad-form-section__title">What went wrong</h5>
            <p class="ad-form-section__desc">Pick the problem you faced with this order and the amount involved.</p>
          </div>
        </div>

        <div class="ad-form-section__grid_2">
          <!-- @if (!comment_id && !commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) { -->
          <div class="ad-form-group">
            <label class="ad-control-label" for="validationIssueRequired">Issue <span class="required">*</span></label>
            <ng-select class="ad-select" bindLabel="name" bindValue="name" placeholder="Select" [closeOnSelect]="true"
              formControlName="reason" [searchable]="true" [items]="issueList">
            </ng-select>
            @if (issueForm.get('reason')?.errors?.['required'] && submitted) {
            <div class="ad-errors">Issue is required</div>
            }
          </div>
          <!-- } @else {
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="ad-form-group mb-3">
              <label for="validationIssue">Issue </label>
              <ng-select class="ad-select" bindLabel="name" bindValue="name" placeholder="Select" [closeOnSelect]="true"
                formControlName="reason" [searchable]="true" [items]="issueList" [readonly]="true">
              </ng-select>
            </div>
          </div>
          } -->

          @if (issueForm.value.refund_approval && commonLogics.roleCtrl([6, 10], 'checkRoleIsEqual')) {
          <div class="ad-form-group">
            <label class="ad-control-label" for="validationOrderPrice">Order price</label>
            <input class="ad-form-control" placeholder="Enter Order price" (keydown)="restrictDecimal($event)"
              formControlName="order_price" type="text" readonly>
            <span class="ad-field-note">Locked once the refund has been approved.</span>
          </div>
          } @else {
          <div class="ad-form-group">
            <label class="ad-control-label" for="validationCustom">Order price</label>
            <input class="ad-form-control" placeholder="Enter order price" (keydown)="restrictDecimal($event)"
              formControlName="order_price" type="number">
          </div>
          }
        </div>
      </section>

      <!-- ── The customer's own account of the problem ────────────────── -->
      @if (commonLogics.roleCtrl([4, 5, 6, 10], 'checkRoleIsEqual') || issueForm.value.user_comment) {
      <section class="ad-form-section">
        <div class="ad-form-section__head">
          <span class="ad-form-section__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"
                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
            </svg>
          </span>
          <div>
            <h5 class="ad-form-section__title">Describe the issue</h5>
            <p class="ad-form-section__desc">Anything that helps support understand what happened.</p>
          </div>
        </div>

        <div class="ad-form-section__grid">
          @if (commonLogics.roleCtrl([4, 5, 6, 10], 'checkRoleIsEqual')) {
          <div class="ad-form-group">
            <label class="ad-control-label" for="command">Comment</label>
            <textarea class="ad-textarea" formControlName="user_comment" rows="4" cols="80"
              placeholder="e.g. the parcel arrived damaged, the rider never reached the drop point&hellip;"></textarea>
          </div>
          } @else {
          @if (issueForm.value.user_comment) {
          <div class="ad-form-group">
            <label class="ad-control-label" for="command">Comment</label>
            <textarea class="ad-textarea" formControlName="user_comment" rows="4" cols="80" readonly></textarea>
          </div>
          }
          }
        </div>
      </section>
      }

      <!-- ── Refund decision ─────────────────────────────────────────── -->
      @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') || issueForm.value.refund_approval) {
      <section class="ad-form-section">
        <div class="ad-form-section__head">
          <span class="ad-form-section__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7">
                <path d="M3 5h18v14H3z" />
                <path d="M3 10h18M7 15h4" />
              </g>
            </svg>
          </span>
          <div>
            <h5 class="ad-form-section__title">Refund decision</h5>
            <p class="ad-form-section__desc">Whether this issue is refunded, and where the partner claim stands.</p>
          </div>
        </div>

        <div class="ad-form-section__grid_2">
          <div class="d-flex flex-column w-100">
            <label class="ad-control-label" for="val1">Refund or Declined</label>
            @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
            <div class="ad-choice-card w-100">
              <div class="checkbox checkbox-primary">
                <input id="issue_refund_approval" type="checkbox" formControlName="refund_approval">
                <label for="issue_refund_approval">Refund Approval</label>
              </div>
            </div>
            } @else {
            @if (issueForm.value.refund_approval) {
            <div class="ad-choice-card disabled-upload w-100">
              <div class="checkbox checkbox-primary">
                <input id="issue_refund_approval" type="checkbox" formControlName="refund_approval" [disabled]="true">
                <label for="issue_refund_approval">Refund Approval</label>
              </div>
            </div>
            }
            }

            @if (issueForm.value.refund_approval) {
            <div class="ad-radio-group w-100 mt-2">
              @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
              <label class="ad-radio-option" for="issue_cus_refunded">
                <input id="issue_cus_refunded" type="radio" name="cus_refunded_status" [value]="true"
                  (change)="refundCusStatusChangeRefunded()" formControlName="cus_refunded_status">
                <span class="ad-radio-option__label">Refunded</span>
              </label>
              } @else {
              @if (issueForm.value.refund_status_to_cus === 'Refunded') {
              <label class="ad-radio-option disabled-upload" for="issue_cus_refunded">
                <input id="issue_cus_refunded" type="radio" name="cus_refunded_status" [value]="true"
                  formControlName="cus_refunded_status" [disabled]="true">
                <span class="ad-radio-option__label">Refunded</span>
              </label>
              }
              }

              @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
              <label class="ad-radio-option" for="issue_cus_declined">
                <input id="issue_cus_declined" type="radio" name="cus_refunded_status" [value]="false"
                  (change)="refundCusStatusChangeDecline()" formControlName="cus_refunded_status">
                <span class="ad-radio-option__label">Decline</span>
              </label>
              } @else {
              @if (issueForm.value.refund_status_to_cus === 'Decline') {
              <label class="ad-radio-option" for="issue_cus_declined">
                <input id="issue_cus_declined" type="radio" name="cus_refunded_status" [value]="false"
                  formControlName="cus_refunded_status" [disabled]="true">
                <span class="ad-radio-option__label">Declined</span>
              </label>
              }
              }
            </div>
            }
          </div>

          @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
          <div class="ad-form-group ad-refund-grid__partner w-100">
            <label class="ad-control-label" for="val1">Refund partner status</label>
            <ng-select class="ad-select" bindLabel="name" bindValue="name" placeholder="Select" [closeOnSelect]="true"
              formControlName="refund_status_from_partner" [searchable]="true" [items]="constant.issueStatus">
            </ng-select>
          </div>
          }
        </div>
      </section>
      }

      <!-- ── Screenshots ─────────────────────────────────────────────── -->
      <section class="ad-form-section">
        <div class="ad-form-section__head">
          <span class="ad-form-section__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7">
                <path d="M3 5h18v14H3z" />
                <path d="m3 16l5-5 4 4 3-3 6 6" />
                <circle cx="9" cy="9.5" r="1.4" />
              </g>
            </svg>
          </span>
          <div>
            <h5 class="ad-form-section__title">Screenshots</h5>
            <p class="ad-form-section__desc">Proof speeds up the decision &mdash; a photo of the parcel, the app screen
              or the bill.</p>
          </div>
        </div>

        <!-- Customer side -->
        <div class="ad-shot-group">
          <p class="ad-shot-group__label">
            {{ commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') ? 'Customer uploads' : 'Your uploads' }}
          </p>

          <div class="ad-shot-grid">
            @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') || fileUrl) {
            <div class="ad-shot">
              <div class="ad-shot__bar">
                <span class="ad-shot__slot">Screenshot 1</span>
                @if (issueForm.value.doc1) {
                <span class="ad-acreen-download">
                  <a href="javascript:;" class="ad-dl" (click)="DownloadImage(fileUrl,'doc1')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                    </svg>
                    <span>Download</span>
                  </a>
                </span>
                }
              </div>

              <div class="ad-form-group ad-screen-shot-wrpper">
                <div class="user-image">
                  @if (fileUrl?.includes('.jpeg') || fileUrl?.includes('.jpg') || fileUrl?.includes('.png')) {
                  <div class="avatar is-photo">
                    <img alt="" [src]="fileUrl || 'assets/images/no-image.png'">
                  </div>
                  } @else {
                  <div class="avatar">
                    @if (!fileName) {
                    <div class="ad-inner-avatar">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <path d="m7 9l5-5 5 5M12 4v12" />
                        </g>
                      </svg>
                    </div>
                    }
                    @if (fileName) {
                    <div class="ad-inner-avatar is-file">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <path d="M14 2v6h6" />
                        </g>
                      </svg>
                    </div>
                    }
                  </div>
                  }

                  <div class="ad-upload-title">
                    @if (!fileName) {
                    <label class="ad-control-label">Upload a file</label>
                    @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">PNG, JPG or PDF</span>
                    }
                    }
                    @if (fileName) {
                    <label class="ad-control-label" [title]="fileName">{{fileName}}</label>
                    @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">Click to replace</span>
                    }
                    }
                  </div>

                  @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                  <div class="icon-wrapper" #fileUploadWrapper1>
                    <input class="upload" type="file" (change)="readUrlFile($event)" />
                  </div>
                  }
                </div>
              </div>
            </div>
            }

            @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') || fileUrl1) {
            <div class="ad-shot">
              <div class="ad-shot__bar">
                <span class="ad-shot__slot">Screenshot 2</span>
                @if (issueForm.value.doc2) {
                <span class="ad-acreen-download">
                  <a href="javascript:;" class="ad-dl" (click)="DownloadImage(fileUrl1,'doc2')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                    </svg>
                    <span>Download</span>
                  </a>
                </span>
                }
              </div>

              <div class="ad-form-group ad-screen-shot-wrpper">
                <div class="user-image">
                  @if (fileUrl1?.includes('.jpeg') || fileUrl1?.includes('.jpg') ||
                  fileUrl1?.includes('.png')) {
                  <div class="avatar is-photo">
                    <img alt="" [src]="fileUrl1 || 'assets/images/no-image.png'" height="100" width="100">
                  </div>
                  } @else {
                  <div class="avatar">
                    @if (!fileName1) {
                    <div class="ad-inner-avatar">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <path d="m7 9l5-5 5 5M12 4v12" />
                        </g>
                      </svg>
                    </div>
                    }
                    @if (fileName1) {
                    <div class="ad-inner-avatar is-file">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <path d="M14 2v6h6" />
                        </g>
                      </svg>
                    </div>
                    }
                  </div>
                  }

                  <div class="ad-upload-title">
                    @if (!fileName1) {
                    <label class="ad-control-label">Upload a file</label>
                    @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">PNG, JPG or PDF</span>
                    }
                    }
                    @if (fileName1) {
                    <label class="ad-control-label" [title]="fileName1">{{fileName1}}</label>
                    @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">Click to replace</span>
                    }
                    }
                  </div>

                  @if (!commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                  <div class="icon-wrapper" #fileUploadWrapper2>
                    <input class="upload" type="file" (change)="readUrlFile1($event)" />
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>

        <!-- Support side -->
        @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')|| (comment_id && (fileUrl2))) {
        <div class="ad-shot-group">
          <p class="ad-shot-group__label">Support uploads</p>

          <div class="ad-shot-grid">
            @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') || fileUrl2) {
            <div class="ad-shot">
              <div class="ad-shot__bar">
                <span class="ad-shot__slot">Screenshot 3</span>
                @if (issueForm.value.doc3) {
                <span class="ad-acreen-download">
                  <a href="javascript:;" class="ad-dl" (click)="DownloadImage(fileUrl2,'doc3')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                    </svg>
                    <span>Download</span>
                  </a>
                </span>
                }
              </div>

              <div class="ad-form-group ad-screen-shot-wrpper">
                <div class="user-image">
                  @if (fileUrl2?.includes('.jpeg') || fileUrl2?.includes('.jpg') || fileUrl2?.includes('.png')) {
                  <div class="avatar is-photo">
                    <img alt="" [src]="fileUrl2? fileUrl2:'assets/images/no-image.png'" height="100" width="100">
                  </div>
                  } @else {
                  <div class="avatar">
                    @if (!fileName2) {
                    <div class="ad-inner-avatar">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <path d="m7 9l5-5 5 5M12 4v12" />
                        </g>
                      </svg>
                    </div>
                    }
                    @if (fileName2) {
                    <div class="ad-inner-avatar is-file">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <path d="M14 2v6h6" />
                        </g>
                      </svg>
                    </div>
                    }
                  </div>
                  }

                  <div class="ad-upload-title">
                    @if (!fileName2) {
                    <label class="ad-control-label">Upload a file</label>
                    @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">PNG, JPG or PDF</span>
                    }
                    }
                    @if (fileName2) {
                    <label class="ad-control-label" [title]="fileName2">{{fileName2?fileName2:''}}</label>
                    @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">Click to replace</span>
                    }
                    }
                  </div>

                  @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                  <div class="icon-wrapper">
                    <input class="upload" type="file" (change)="readUrlFile2($event)" #fileUploadWrapper3 />
                  </div>
                  }
                </div>
              </div>
            </div>
            }

            @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') || fileUrl3) {
            <div class="ad-shot">
              <div class="ad-shot__bar">
                <span class="ad-shot__slot">Screenshot 4</span>
                @if (issueForm.value.doc4) {
                <span class="ad-acreen-download">
                  <a href="javascript:;" class="ad-dl" (click)="DownloadImage(fileUrl3,'doc4')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                    </svg>
                    <span>Download</span>
                  </a>
                </span>
                }
              </div>

              <div class="ad-form-group ad-screen-shot-wrpper">
                <div class="user-image">
                  @if (fileUrl3?.includes('.jpeg') || fileUrl3?.includes('.jpg') || fileUrl3?.includes('.png')) {
                  <div class="avatar is-photo">
                    <img alt="" [src]="fileUrl3? fileUrl3:'assets/images/no-image.png'" height="100" width="100">
                  </div>
                  } @else {
                  <div class="avatar">
                    @if (!fileName3) {
                    <div class="ad-inner-avatar">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <path d="m7 9l5-5 5 5M12 4v12" />
                        </g>
                      </svg>
                    </div>
                    }
                    @if (fileName3) {
                    <div class="ad-inner-avatar is-file">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.7">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <path d="M14 2v6h6" />
                        </g>
                      </svg>
                    </div>
                    }
                  </div>
                  }

                  <div class="ad-upload-title">
                    @if (!fileName3) {
                    <label class="ad-control-label">Upload a file</label>
                    @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">PNG, JPG or PDF</span>
                    }
                    }
                    @if (fileName3) {
                    <label class="ad-control-label" [title]="fileName3">{{fileName3?fileName3:''}}</label>
                    @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                    <span class="ad-shot__hint">Click to replace</span>
                    }
                    }
                  </div>

                  @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
                  <div class="icon-wrapper">
                    <input class="upload" type="file" (change)="readUrlFile3($event)" #fileUploadWrapper4 />
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }

        @if (requireImg) {
        <div class="error-img">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 8v4m0 4h.01" />
            </g>
          </svg>
          <span>Please upload at least one screenshot before saving.</span>
        </div>
        }
      </section>

      <!-- ── Support response ────────────────────────────────────────── -->
      @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') || issueForm.value.support_comment) {
      <section class="ad-form-section">
        <div class="ad-form-section__head">
          <span class="ad-form-section__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7">
                <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
                <path
                  d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
              </g>
            </svg>
          </span>
          <div>
            <h5 class="ad-form-section__title">Support response</h5>
            <p class="ad-form-section__desc">
              {{ commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') ? 'Visible to the customer once you save.' : 'What
              our support team has said about this issue.' }}
            </p>
          </div>
        </div>

        <div class="ad-form-section__grid">
          @if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
          <div class="ad-form-group">
            <label class="ad-control-label" for="command">Support comment</label>
            <textarea class="ad-textarea" formControlName="support_comment" placeholder="Comments here..." rows="4"
              cols="80"></textarea>
          </div>
          } @else {
          @if (issueForm.value.support_comment) {
          <div class="ad-form-group">
            <label class="ad-control-label" for="command">Support comment</label>
            <textarea class="ad-textarea" formControlName="support_comment" placeholder="Comments here..." rows="4"
              cols="80" readonly></textarea>
          </div>
          }
          }
        </div>
      </section>
      }

    </form>
  </div>

  <!-- ───────────────────────────────────────────────────────────── Footer -->
  @if ( commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') || this.dataNullCheck ||
  this.localData.getItem(constant.localStorage.user_id) == this.created_user_id) {
  <div class="card-footer action-buttons-container justify-content-end">
    <button type="button" (click)="closeModal()" class="btn ad-btn-small btn-gray">
      <span>Cancel</span>
    </button>
    <button type="button" (click)="updateOrderissue()" class="btn ad-btn-small active" data-dismiss="modal">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M16.25 21v-4.765a1.59 1.59 0 0 0-1.594-1.588H9.344a1.59 1.59 0 0 0-1.594 1.588V21m8.5-17.715v2.362a1.59 1.59 0 0 1-1.594 1.588H9.344A1.59 1.59 0 0 1 7.75 5.647V3m8.5.285A3.2 3.2 0 0 0 14.93 3H7.75m8.5.285c.344.156.661.374.934.645l2.382 2.375A3.17 3.17 0 0 1 20.5 8.55v9.272A3.18 3.18 0 0 1 17.313 21H6.688A3.18 3.18 0 0 1 3.5 17.823V6.176A3.18 3.18 0 0 1 6.688 3H7.75" />
      </svg>
      <span>Save</span>
    </button>
  </div>
  }
</div>